import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static values = { bound: Boolean };

  static targets = ['name', 'domain', 'domainPreview'];

  initialize() {
    this.setBoundedness = this.setBoundedness.bind(this);
    this.setNameToDomain = this.setNameToDomain.bind(this);
    this.setNameToDomainPreview = this.setNameToDomainPreview.bind(this);
    this.domainify = this.domainify.bind(this);
  }

  connect() {
    useEventListener(this, this.nameTarget, 'input', () => this.setNameToDomain());

    useEventListener(this, this.domainTarget, 'input', () => {
      this.setBoundedness();
      this.domainTarget.value = this.domainify(this.domainTarget.value);
      this.setNameToDomainPreview();
    });

    this.setBoundedness();
  }

  setBoundedness() {
    if (
      this.domainTarget.value === ''
      || this.domainify(this.domainTarget.value) === this.nameTarget.value
    ) {
      this.boundValue = true;
    } else {
      this.boundValue = false;
    }
  }

  setNameToDomain() {
    if (this.boundValue === true) {
      const domainifiedName = this.domainify(this.nameTarget.value);
      this.domainTarget.value = domainifiedName;
      this.setNameToDomainPreview();
    }
  }

  setNameToDomainPreview() {
    if (this.domainTarget.value === '') {
      this.domainPreviewTarget.innerHTML = this.domainify(this.domainTarget.placeholder);
    } else {
      this.domainPreviewTarget.innerHTML = this.domainify(this.domainTarget.value);
    }
  }

  domainify(name) {
    const forbiddenChars = /[^a-z\d\s-]/ig;
    return name
      .trim()
      .replace(forbiddenChars, '')
      .replace(/\s{2,}/g, ' ')
      .split(' ')
      .join('-')
      .toLowerCase();
  }
}
